import { render, staticRenderFns } from "./AirFreightIcon.vue?vue&type=template&id=390e5d3c&"
import script from "./AirFreightIcon.vue?vue&type=script&lang=js&"
export * from "./AirFreightIcon.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports